/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `DateNav`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  DateRangeSelectOptions: {
    SevenDays: `7 أيام`,
    ThirtyDays: `30 أيام`,
    ThreeDays: `3 أيام`,
  },
  TodayLabel: `اليوم`,
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  DateRangeSelectOptions: {
    SevenDays: `7 Days / Page`,
    ThirtyDays: `30 Days / Page`,
    ThreeDays: `3 Days / Page`,
  },
  TodayLabel: `Today`,
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  DateRangeSelectOptions: {
    SevenDays: `7天`,
    ThirtyDays: `30天`,
    ThreeDays: `3天`,
  },
  TodayLabel: `今天`,
});
